import { useQuery } from "react-query";

import { makeRequest } from "@/util";
import { Form } from "../forms_types";

export default function useForms() {
  return useQuery<Form[]>("get_forms", async () => {
    try {
      const res = await makeRequest<Form[]>("get_forms", {});
      return res.data;
    } catch {
      return [];
    }
  });
}
